export enum DataLayerCustomDimensions {
  USER_ID   = 'userId',
  USER_TYPE = 'userType'
}
